module.exports = __webpack_public_path__ + "static/teag-8698ad5d8646a654c6b685e95bb94234.png";